import React from "react";
import { Typography } from "antd";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

const { Text } = Typography;

const TextItem = (props) => {
  const { name, auto } = props;
  const intl = useIntl();
  const c = auto ? "item_container_auto" : "item_container";

  return (
    <div className={c}>
      <Text>
        {intl.formatMessage({
          id: "app.work_diary_print." + name,
        })}
      </Text>
    </div>
  );
};

TextItem.propTypes = {
  name: PropTypes.string,
  content: PropTypes.string,
};

export default TextItem;
